import { useState } from "react";
import { getFormUrl } from "@/utils/getFormUrl";
import SEO from "@/components/base/SEO";
import Breadcrumb from "@/components/base/Breadcrumb";

const testimonials = [
  {
    name: "张先生",
    role: "互联网从业者",
    content: "福利导航帮我省了不少钱！双十一的时候在上面找到了好多隐藏优惠券，最后算下来比原价便宜了近一半。强烈推荐给所有人！",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20with%20warm%20friendly%20expression%20on%20cream%20background%2C%20clean%20studio%20portrait%2C%20soft%20lighting&width=80&height=80&seq=avatar-zhang&orientation=squarish",
  },
  {
    name: "李女士",
    role: "全职妈妈",
    content: "作为一个精打细算的妈妈，福利导航简直是我的每日必看。政府福利板块让我了解了原来有这么多补贴可以申请，真的帮了大忙！",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20with%20warm%20friendly%20smile%20on%20cream%20background%2C%20clean%20studio%20portrait%2C%20soft%20lighting&width=80&height=80&seq=avatar-li&orientation=squarish",
  },
  {
    name: "王同学",
    role: "大学生",
    content: "教育福利板块太实用了！找到了好多免费课程资源，还在上面了解到学生可以申请的各类补贴。学习省钱两不误。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20young%20Chinese%20student%20portrait%20with%20friendly%20expression%20on%20cream%20background%2C%20clean%20studio%20portrait%2C%20soft%20lighting&width=80&height=80&seq=avatar-wang&orientation=squarish",
  },
];

export default function AboutPage() {
  const [formState, setFormState] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [formUrl, setFormUrl] = useState("");

  useState(() => {
    getFormUrl("contact").then((data) => {
      setFormUrl(data.submitAddr);
    });
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formUrl) return;
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get("phone_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setFormState("success");
      form.reset();
      return;
    }

    formData.delete("phone_alt");

    try {
      const response = await fetch(formUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === "OK") {
        setFormState("success");
        form.reset();
      } else {
        const errMsg =
          parsed?.meta?.message || parsed?.message || responseText || "提交失败，请稍后重试";
        setFormState("error");
        setFormError(errMsg);
      }
    } catch {
      setFormState("error");
      setFormError("网络错误，请稍后重试");
    }
  };

  const seoData = {
    title: "关于我们",
    description:
      "福利导航是一个一站式福利资源聚合平台，汇聚全网优质福利资源。了解我们的品牌故事、用户口碑以及联系方式。",
    keywords: "福利导航,关于福利导航,福利资源平台,品牌介绍,用户口碑,联系我们",
    canonicalUrl: "https://jobbang.cn/about",
    schema: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "福利导航",
      url: "https://jobbang.cn",
      description:
        "一站式福利资源聚合平台，汇聚全网优质福利资源，覆盖电商优惠、会员权益、生活补贴、政府福利等八大品类。",
      foundingDate: "2023",
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        email: "contact@jobbang.cn",
        availableLanguage: "Chinese",
      },
    },
  };

  return (
    <>
      <SEO data={seoData} />
      <main className="min-h-screen bg-background-50 pt-24 pb-12 md:pb-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: "首页", href: "/" }, { label: "关于我们" }]} />

          <section className="mt-6 mb-12 md:mb-16">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-6">
              关于福利导航
            </h1>
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <div className="flex items-center gap-3 mb-5">
                <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-gift-line text-background-50 text-xl"></i>
                </span>
                <span className="text-xl font-semibold text-foreground-950 font-heading">
                  品牌介绍
                </span>
              </div>
              <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4">
                <p>
                  <strong className="text-foreground-950">福利导航</strong>成立于2023年，是一个专注于汇聚和整理全网优质福利资源的一站式聚合平台。我们致力于帮助广大用户快速找到最实用的福利入口，省时省钱，轻松享受各类专属权益。
                </p>
                <p>
                  我们的团队由一群热爱生活的年轻人组成，深知在信息爆炸的时代，找到真正有价值的福利资源并不容易。因此，我们建立了覆盖<strong className="text-foreground-950">电商优惠、会员权益、生活补贴、政府福利、金融服务、教育福利、健康医疗、出行交通</strong>等八大品类的福利资源库，每日追踪更新。
                </p>
                <p>
                  截至目前，福利导航已收录<strong className="text-foreground-950">超过700项优质福利资源</strong>，月活跃用户突破<strong className="text-foreground-950">50万</strong>，用户好评率高达98%。我们始终坚持以用户需求为导向，持续优化内容和体验。
                </p>
                <p>
                  我们的使命是让每个人都能轻松享受生活中的各种福利，让好资源不再被错过。未来，福利导航将继续拓展资源覆盖范围，引入更多品类的优质福利，为更多用户创造价值。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-12 md:mb-16">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <h3 className="text-base font-semibold text-foreground-950 mb-4">联系方式</h3>
                <div className="space-y-3 text-sm text-foreground-600">
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line"></i>
                    </span>
                    <span>contact@jobbang.cn</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-map-pin-line"></i>
                    </span>
                    <span>中国 · 北京</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-time-line"></i>
                    </span>
                    <span>工作日 9:00 - 18:00</span>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <h3 className="text-base font-semibold text-foreground-950 mb-4">在线留言</h3>
                {formState === "success" ? (
                  <div className="text-center py-8">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-check-line text-2xl"></i>
                    </div>
                    <p className="text-sm text-foreground-700 font-medium">提交成功！</p>
                    <p className="text-xs text-foreground-500 mt-1">感谢您的留言，我们会尽快回复</p>
                    <button
                      type="button"
                      className="mt-4 text-sm text-primary-600 hover:underline cursor-pointer"
                      onClick={() => setFormState("idle")}
                    >
                      继续留言
                    </button>
                  </div>
                ) : (
                  <form
                    id="contact-form"
                    data-readdy-form
                    onSubmit={handleSubmit}
                    action={formUrl}
                    method="POST"
                    className="space-y-4"
                  >
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1">
                        姓名
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="w-full px-3 py-2 rounded-md border border-background-300/60 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1">
                        邮箱
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-3 py-2 rounded-md border border-background-300/60 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1">
                        留言
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        required
                        maxLength={500}
                        rows={3}
                        className="w-full px-3 py-2 rounded-md border border-background-300/60 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent resize-none"
                        placeholder="请输入您的留言（500字以内）"
                      ></textarea>
                    </div>

                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="absolute opacity-0 pointer-events-none"
                    />

                    {formState === "error" && (
                      <p className="text-sm text-red-600">{formError}</p>
                    )}

                    <button
                      type="submit"
                      className="w-full py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      提交留言
                    </button>
                  </form>
                )}
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}